/* =========================================================================
   LIQUID GOLD — CART DELIVERY PANEL  (v5, 24 Sep 2026)

   Renders above the checkout button on the cart page and in the cart drawer:
     1. A minimum-order table for all five delivery tiers
     2. A ZIP box that checks the live cart against Shopify's own rates
     3. A checkout gate — blocked until the order qualifies

   The customer's own tier highlights once they enter their ZIP.

   >>> IF A MINIMUM OR FEE CHANGES IN SHOPIFY, CHANGE IT IN ZONES AND TIERS.
       Table last synced to Shopify: 24 September 2026.

   TO DISABLE: set LG_ENABLED to false, or remove the <script> line from
   layout/theme.liquid.
   ========================================================================= */
(function () {
  'use strict';

  var LG_ENABLED = true;
  if (!LG_ENABLED) return;

  /* Hide Shopify's express wallet buttons (Shop Pay, PayPal, Amazon Pay,
     Apple Pay) wherever they render on the storefront. They create a checkout
     straight from the cart or product page, skipping BOTH this delivery check
     and the PMA membership agreement. Wallets at the checkout page itself are
     unaffected — those still work, and a customer reaches them only after
     passing the cart. Set to false to bring the express buttons back. */
  var LG_HIDE_EXPRESS = true;

  /* ---- Delivery zones. min / fee in CENTS. $32.00 = 3200 ---- */
  var Z = [
    ['Petaluma', 0, 0, '94952 94953 94954 94955 94975 94999'],
    ['Penngrove & Cotati', 3200, 500, '94951 94931'],
    ['Rohnert Park', 3200, 750, '94926 94927 94928'],
    ['Santa Rosa, Sonoma & Marin', 3200, 1000,
      '95401 95402 95403 95404 95405 95406 95407 95409 95442 95476 95416 95433 95439 95452 95487 95431 94945 94947 94949 94901 94903 94904 94925 94930 94939 94957 94960 94920 94941 94965 94924 94929 94933 94937 94938 94940 94946 94950 94956 94963 94970 94971 94973'],
    ['Sebastopol, Windsor & Forestville', 4800, 1500, '95472 95473 95492 95436 95444 95465 95419 94972'],
    ['Far Sonoma', 4800, 2000, '95448 95425 94923 95446 94922 95421 95430 95441 95450 95462 95471 95412 95480 95486 95497'],
    ['Napa & Solano', 4800, 2500,
      '94503 94558 94559 94581 94599 94508 94515 94562 94567 94573 94574 94576 94510 94512 94533 94534 94535 94571 94585 94589 94590 94591 94592 95620 95625 95687 95688'],
    ['SF, East Bay, Contra Costa & Peninsula', 8000, 3000,
      '94102 94103 94104 94105 94107 94108 94109 94110 94111 94112 94114 94115 94116 94117 94118 94121 94122 94123 94124 94127 94129 94130 94131 94132 94133 94134 94158 94501 94502 94601 94602 94603 94605 94606 94607 94608 94609 94610 94611 94612 94618 94619 94621 94702 94703 94704 94705 94706 94707 94708 94709 94710 94720 94530 94506 94507 94517 94523 94525 94526 94547 94549 94553 94556 94563 94564 94572 94595 94596 94597 94598 94801 94803 94804 94805 94806 94518 94519 94520 94521 94541 94542 94544 94545 94546 94552 94577 94578 94579 94580 94005 94010 94014 94015 94030 94044 94066 94080 94401 94402 94403 94404'],
    ['Sacramento & Yolo', 9600, 4500,
      '95814 95815 95816 95817 95818 95819 95820 95821 95822 95823 95824 95825 95826 95827 95828 95829 95831 95832 95833 95834 95835 95838 95605 95608 95610 95621 95624 95628 95630 95650 95655 95660 95661 95662 95670 95673 95677 95678 95682 95683 95691 95693 95742 95746 95747 95757 95758 95762 95765 95606 95607 95612 95616 95618 95627 95637 95645 95679 95694 95695 95697 95776 95937 ' +
      '95811 95841 95842 95843 95864'],
    ['Mendocino & Lake Counties', 9600, 3500,
      '95418 95422 95423 95424 95426 95435 95443 95449 95451 95453 95457 95458 95461 95464 95467 95470 95482 95485 95490 95493 ' +
      '95410 95415 95417 95420 95427 95428 95429 95432 95437 95445 95454 95456 95459 95460 95463 95466 95468 95469 95481 95488 95494 95585 95587']
  ];

  /* Lake County ZIPs currently duplicated into Zone 8 — ambiguous until
     removed there. They get the generic message rather than a wrong number. */
  /* Was used while 15 Lake County ZIPs sat in both Zone 8 and Zone 10.
     They now belong to Mendocino & Lake above. Leave empty. */
  var AMB = '';

  var SEL = '#checkout, button[name="checkout"], [name="checkout"]';
  var PMA = '#pma-agreement-checkbox';

  var MAP = {}, MAXMIN = 0, i, j, p;
  for (i = 0; i < Z.length; i++) {
    if (Z[i][1] > MAXMIN) MAXMIN = Z[i][1];
    p = Z[i][3].split(' ');
    for (j = 0; j < p.length; j++) MAP[p[j]] = Z[i];
  }
  p = AMB.split(' ');
  for (j = 0; j < p.length; j++) MAP[p[j]] = null;

  var st = { zip: '', s: 'idle', fee: null, z: null, sub: null, busy: false };
  try { st.zip = sessionStorage.getItem('lg_zip') || ''; } catch (e) {}

  var obs = null, sched = false, writing = false;

  var sty = document.createElement('style');
  sty.textContent =
    '.lgd{border-top:1px solid rgba(0,0,0,.14);padding:16px 0 10px;margin-bottom:10px;font-family:inherit;color:#141210}' +
    '.lgd-box{border:2px solid #e8b923;border-radius:14px;overflow:hidden;background:#fff;margin-bottom:14px}' +
    '.lgd-hd{background:#e8b923;padding:10px 14px;text-align:center}' +
    '.lgd-hd b{display:block;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:1.2px;line-height:1.3}' +
    '.lgd-hd i{display:block;font-style:normal;font-size:11.5px;margin-top:1px;opacity:.85}' +
    '.lgd-t{padding:4px 14px 10px}' +
    '.lgd-r{display:flex;justify-content:space-between;align-items:baseline;gap:10px;padding:5px 0;border-bottom:1px solid #f0e8d2;font-size:11.5px;line-height:1.3}' +
    '.lgd-r:last-child{border-bottom:0}' +
    '.lgd-r .n{color:#6b6358}' +
    '.lgd-r .v{font-weight:700;white-space:nowrap;text-align:right}' +
    '.lgd-r .v em{display:block;font-style:normal;font-weight:400;font-size:11px;color:#6b6358}' +
    '.lgd-r.on{background:#fdf6de;margin:0 -14px;padding-left:14px;padding-right:14px;border-bottom-color:#e8d9a8}' +
    '.lgd-r.on .n{color:#141210;font-weight:700}' +
    '.lgd-ds{border-top:1px solid #e8d9a8;background:#fdfaf0;padding:9px 14px;font-size:11.5px;line-height:1.45;color:#6b6358;text-align:center}' +
    '.lgd-ds b{display:block;color:#141210;letter-spacing:.9px;text-transform:uppercase;margin-bottom:2px}' +
    '.lgd-lab{display:block;font-size:12.5px;font-weight:700;margin-bottom:8px}' +
    '.lgd-row{display:flex;gap:8px}' +
    '.lgd-in{flex:1;min-width:0;padding:9px 12px;font-size:14px;border:1px solid #141210;background:#fff;color:#141210;border-radius:0}' +
    '.lgd-bt{padding:9px 16px;font-size:13px;font-weight:700;cursor:pointer;border:1px solid #141210;background:#141210;color:#fff;white-space:nowrap;border-radius:0}' +
    '.lgd-bt[disabled]{opacity:.5;cursor:default}' +
    '.lgd-m{margin-top:10px;font-size:12.5px;line-height:1.5}' +
    '.lgd-m.ok{color:#1d6b3f}.lgd-m.wa{color:#8a6100}.lgd-m.no{color:#a42325}' +
    (LG_HIDE_EXPRESS ?
      'shopify-accelerated-checkout,shopify-accelerated-checkout-cart,' +
      '.accelerated-checkout-block,.additional-checkout-buttons,' +
      '.cart__dynamic-checkout-buttons,[data-shopify="dynamic-checkout-cart"],' +
      '[data-shopify="payment-button"],.shopify-payment-button' +
      '{display:none !important}' : '');
  document.head.appendChild(sty);

  function m(c) { var n = Number(c); return isNaN(n) ? '' : '$' + (n / 100).toFixed(2); }

  /* The table is generated from Z, so it can never drift from the zones the
     delivery check actually uses. Bottle counts assume the $8 single-serve
     price — the cheapest item, so the count is always sufficient. */
  function tiers() {
    var out = '';
    for (var k = 0; k < Z.length; k++) {
      var z = Z[k];
      var on  = (z === st.z) ? ' on' : '';
      var amt = z[1] === 0 ? 'No minimum' : '$' + (z[1] / 100).toFixed(0);
      var btl = z[1] === 0 ? 'any amount' : (z[1] / 800) + ' bottles';
      out += '<div class="lgd-r' + on + '">' +
               '<span class="n">' + z[0].replace(/&/g, '&amp;') + '</span>' +
               '<span class="v">' + amt + '<em>' + btl + '</em></span>' +
             '</div>';
    }
    return out;
  }

  function rates(zip) {
    var q = 'shipping_address%5Bcountry%5D=United+States&shipping_address%5Bzip%5D=' + zip, t = 0;
    function go() {
      return fetch('/cart/shipping_rates.json?' + q, { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 200) return r.json();
        if (r.status >= 400 || ++t > 12) return { shipping_rates: [] };
        return new Promise(function (ok) { setTimeout(ok, 600); }).then(go);
      });
    }
    return go();
  }

  function check(zip) {
    st.busy = true; st.s = 'checking'; draw();
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count) { st.s = 'empty'; st.busy = false; draw(); return; }
      var sub = typeof c.items_subtotal_price === 'number' ? c.items_subtotal_price : c.total_price;
      st.sub = sub;
      return rates(zip).then(function (d) {
        var rs = (d && d.shipping_rates) || [];
        var r = rs.filter(function (x) { return /local/i.test(x.name); })[0] || rs[0];
        var z = MAP.hasOwnProperty(zip) ? MAP[zip] : undefined;
        var known = z !== undefined, amb = known && z === null;
        if (r) {
          st.s = 'ok'; st.fee = Math.round(parseFloat(r.price) * 100);
          st.z = (known && !amb && st.fee === z[2]) ? z : null;
        } else if (known && !amb && sub < z[1]) {
          st.s = 'short'; st.z = z; st.fee = null;
        } else if (known && !amb) {
          /* The ZIP is in a zone we know and the cart clears its minimum, but
             Shopify returned nothing — usually rate-limiting. The customer
             qualifies, so never block them for the endpoint's bad day.
             Shopify still enforces the real rule at checkout. */
          st.s = 'ok'; st.z = z; st.fee = z[2];
        } else if (!known && sub >= MAXMIN) {
          st.s = 'out'; st.z = null; st.fee = null;
        } else {
          st.s = 'block'; st.z = null; st.fee = null;
        }
        st.busy = false;
        try { sessionStorage.setItem('lg_zip', zip); } catch (e) {}
        draw();
      });
    }).catch(function () { st.s = 'err'; st.busy = false; draw(); });
  }

  function msg() {
    var s = st.s;
    if (s === 'checking') return ['', 'Checking...'];
    if (s === 'bad')   return ['wa', 'Enter a 5-digit ZIP code.'];
    if (s === 'empty') return ['wa', 'Add something to your cart first.'];
    if (s === 'ok')    return ['ok', 'Delivering to <strong>' + st.zip + '</strong>' + (st.z ? ' &middot; ' + st.z[0] : '') + ' &mdash; <strong>' + (st.fee === 0 ? 'free' : m(st.fee)) + '</strong>.'];
    if (s === 'short') return ['no', 'This delivery zone is a <strong>' + m(st.z[1]) + ' minimum order</strong>. You&rsquo;re at ' + m(st.sub) + ' &mdash; add <strong>' + m(st.z[1] - st.sub) + '</strong> more to check out.'];
    if (s === 'out')   return ['no', 'Sorry &mdash; we don&rsquo;t deliver to <strong>' + st.zip + '</strong> yet.'];
    if (s === 'block') return ['no', 'We can&rsquo;t confirm delivery to <strong>' + st.zip + '</strong> with this order. It&rsquo;s either outside our area or below that area&rsquo;s minimum &mdash; add a few more bottles and check again.'];
    if (s === 'err')   return ['wa', 'We couldn&rsquo;t check delivery just now. You can continue &mdash; delivery is confirmed at checkout.'];
    return ['', 'Enter your ZIP to confirm delivery and unlock checkout.'];
  }

  function panel() {
    var e = document.createElement('div');
    e.className = 'lgd';
    e.setAttribute('data-lgd', '');
    e.innerHTML =
      '<div class="lgd-box">' +
        '<div class="lgd-hd"><b>Local delivery only</b><i>Minimum order by area</i></div>' +
        '<div class="lgd-t" data-lgd-t></div>' +
        '<div class="lgd-ds"><b>Dispatch Tue &amp; Fri</b>' +
          'Order by Sun 4:30pm PST for Tuesday &middot; Wed 4:30pm PST for Friday' +
        '</div>' +
      '</div>' +
      '<span class="lgd-lab">Where are we delivering?</span>' +
      '<div class="lgd-row">' +
        '<input class="lgd-in" type="text" inputmode="numeric" maxlength="5" placeholder="ZIP code" aria-label="Delivery ZIP code">' +
        '<button type="button" class="lgd-bt">Check</button>' +
      '</div>' +
      '<div class="lgd-m" role="status" aria-live="polite"></div>';

    var inp = e.querySelector('.lgd-in'), b = e.querySelector('.lgd-bt');
    inp.value = st.zip;
    function go() {
      var v = (inp.value || '').replace(/\D/g, '').slice(0, 5);
      inp.value = v;
      if (v.length !== 5) { st.s = 'bad'; draw(); return; }
      st.zip = v; check(v);
    }
    b.addEventListener('click', go);
    inp.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); go(); } });
    inp.addEventListener('input', function () { if (st.s !== 'idle') { st.s = 'idle'; st.fee = null; st.z = null; draw(); } });
    return e;
  }

  /* Guarded writes — nothing touches the DOM unless the value changed. */
  function draw() {
    writing = true;
    try {
      var ps = document.querySelectorAll('[data-lgd]'), mm = msg();
      var cls = 'lgd-m' + (mm[0] ? ' ' + mm[0] : ''), lbl = st.busy ? '...' : 'Check';
      var tbl = tiers();
      for (var a = 0; a < ps.length; a++) {
        var q = ps[a];
        var inp = q.querySelector('.lgd-in'), b = q.querySelector('.lgd-bt');
        var mo = q.querySelector('.lgd-m'), tb = q.querySelector('[data-lgd-t]');
        if (tb && tb.innerHTML !== tbl) tb.innerHTML = tbl;
        if (inp && document.activeElement !== inp && inp.value !== st.zip) inp.value = st.zip;
        if (b) { if (b.disabled !== st.busy) b.disabled = st.busy; if (b.textContent !== lbl) b.textContent = lbl; }
        if (mo) { if (mo.className !== cls) mo.className = cls; if (mo.innerHTML !== mm[1]) mo.innerHTML = mm[1]; }
      }
    } finally { writing = false; }
    gate();
  }

  function gate() {
    var okd = st.s === 'ok' || st.s === 'err';
    var pm = document.querySelector(PMA);
    var allow = okd && (pm ? pm.checked : true);
    var op = allow ? '' : '0.4', cu = allow ? '' : 'not-allowed';
    var bs = document.querySelectorAll(SEL);
    for (var c = 0; c < bs.length; c++) {
      var b = bs[c];
      if (b.disabled !== !allow) b.disabled = !allow;
      if (b.style.opacity !== op) b.style.opacity = op;
      if (b.style.cursor !== cu) b.style.cursor = cu;
    }
  }

  function mount() {
    if (obs) obs.disconnect();
    try {
      var bs = document.querySelectorAll(SEL);
      for (var d = 0; d < bs.length; d++) {
        var b = bs[d], h = b.parentNode;
        if (!h || h.querySelector('[data-lgd]')) continue;
        h.insertBefore(panel(), b);
      }
      draw();
    } finally { if (obs) obs.observe(document.body, { childList: true, subtree: true }); }
    if (st.zip.length === 5 && st.s === 'idle') check(st.zip);
  }

  function tick() {
    if (sched || writing) return;
    sched = true;
    requestAnimationFrame(function () { sched = false; mount(); });
  }

  function boot() {
    obs = new MutationObserver(tick);
    mount();
    ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { if (st.zip.length === 5) check(st.zip); else draw(); });
    });
    setInterval(gate, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
